// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__VdCXi","pulse":"styles_pulse__7HXCf","jump":"styles_jump__659NX","wiggle":"styles_wiggle__jHX_A"};